import container from "@/lib/di/container";
import { useState, useEffect } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType, handleAddressChange } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { Button, message, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { activeStatusPipe } from "@/core/pipes/active-status.pipe";
import AuthRepo from "@/core/repos/auth.repo";
import { DeleteButton } from "../../components/table/DeleteButton";
import { DepartmentRepo } from "@/core/repos/tables/department.repo";
import { DepartmentModel, DepartmentModelFactory } from "@/core/models/department.model";
import { DetailModal } from "./modals/DetailModal";

const departmentRepo = container.get(DepartmentRepo);
const authRepo = container.get(AuthRepo);

export default function DepartmentsPage() {
    const titleData = useTitleDataStore();
    const userDetail = authRepo.useDetails();
    const [modalData, setModalData] = useState<DepartmentModel>(DepartmentModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<DepartmentModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates, setFilterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tìm kiếm",
            placeholder: "Nhập tìm kiếm",
            type: FilterInputType.text,
        },
    ])

    useEffect(() => {init()}, []);

    const init = async () => {
        await authRepo.getUserData();
    }

    useEffect(()=>{
        titleData.setTitleActions({
            text: "Tạo Phòng ban",
            onPress: () => {
                showDetail(DepartmentModelFactory.getEmpty())
            }
        })
    }, [userDetail])



    async function onFilterChange(map: Map<string, FilterSearchPayload>, changes: string[]) {
        await handleAddressChange(map, changes, filterTemplates, setFilterTemplates);
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: DepartmentModel[]) {
        setSelectedRows([...rows]);
    }

    const showDetail = (record: DepartmentModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const deleteSelected =  async () => {
        setDeleting(true);
        const result = await departmentRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }

    return (
    <div className="px-4 py-6">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<DepartmentModel>
                columns={[
                    { dataIndex: 'code', name: 'Mã phòng ban', width: 150},
                    { dataIndex: 'name', name: 'Tên phòng ban'},
                    { dataIndex: 'information', name: 'Mô tả'},
                    {
                        name: 'Thao tác',
                        width: 100,
                        render: (_, record) => (
                                <div className="flex flex-row px-1 items-center justify-center">
                                    <Tooltip title="Sửa bản ghi"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                                </div>
                            ),
                        fixed: "right"
                    },
                ]}
                repository={departmentRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
    </div>)
}